import { Organization } from 'src/app/model/organization/organization';
import { County } from './county';
import { Region } from './region.model';

export class SchoolDistrict {
    ID: number;
    isSelected?: boolean;
    ORGANIZATIONS_ID: number;
    NCESDist: string;
    DISTRICTS!: string;
    CODE: string;
    ORGANIZATION: Organization;
    COUNTy: County;
    REGION: Region;
    CREATED_BY: string;
    CREATED_DATE: Date;
    MODIFIED_BY: string;
    MODIFIED_DATE: Date;

    REGIONS!: Region;
}

export function compareDistrict(d1: SchoolDistrict, d2: SchoolDistrict) {
    const compare = parseInt(d2.DISTRICTS) - parseInt(d1.DISTRICTS);

    if (compare < 0) {
        return 1;
    } else if (compare > 0) {
        return -1;
    } else return 0;
}
